<template>
  <el-container class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" content="查看创意"></el-page-header>
    </el-header>
    <DetailTemplate referer="idea" :id="id"></DetailTemplate>
  </el-container>
</template>

<script>
import DetailTemplate from './DetailTemplate'

export default {
  name: 'Detail',
  components: {
    DetailTemplate
  },
  data () {
    return {
      id: ''
    }
  },
  computed: {},
  created () {
    this.id = this.$route.query.id
  },
  mounted () {},
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  },
  methods: {
    close () {
      this.myOption.navigateTo(this, '/home/idea/list')
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/idea/Detail.vue